<section class="profile">
  <ng-container *ngIf="position; else loading">
      <div class="profile__inner-wrapper">
          <app-profile-header [position]="position" [isColaboratorModule]="true" (updateCollab)="loadEmployeeInfos()"></app-profile-header>
          <section class="profile__container">
              <aside class="profile__sidebar">
                  <ui-profile-sidebar [infos]="position" [newBrand]="true" [isColaboratorModule]="true"></ui-profile-sidebar>
              </aside>
              <section class="profile__content">
                  <div *ngIf="isBlocked" class="profile__status-message">
                    <div class="profile__status-message__content">
                      <p>Colaborador bloqueado</p>
                      <button type="button" (click)="unBlockSalaryAdvance()" data-test="btnUnblockBenefit">Desbloquear</button>
                    </div>
                  </div>
                  <router-outlet (deactivate)="onDeactivate()"></router-outlet>
              </section>
          </section>
      </div>
  </ng-container>
  <ng-template #loading>
      <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
      </div>
  </ng-template>
</section>
